import { CustomAsyncSelect } from "components/Common/Common";
import SaveRecommendationTemplatePop from "components/Modals/SaveRecommendationTemplate";
import CustomEditor from "components/TipTapEditor/CustomeEditor";
import { useFormikContext } from "formik";
import useModal from "hooks/useModal";
import { useState } from "react";
import { useLazyGetRecommendationTemplatesQuery } from "store/services/clients/reports-v2/recommendationTemplates";

const QuestionSingleRecommendation = ({ clientType, assessmentId, repeat = 2, question, charLimit }) => {
  const fieldName = question?.id;
  const { setFieldValue, values } = useFormikContext();

  // save template modal
  const { show, data, open, close } = useModal();

  const [getTemplates, { isFetching }] = useLazyGetRecommendationTemplatesQuery();

  const getTemplateOptions = async (search) => {
    try {
      const data = await getTemplates({ assessmentId, search, clientType, status: "" }).unwrap();
      const templates = data?.records || [];
      return templates?.map(i => ({ label: i.title, value: i }))
    } catch (error) {
      console.log("Error Getting template options", error);
    };
  };

  return (
    <div>
      <SaveRecommendationTemplatePop
        showPopup={show}
        closePopup={close}
        data={data}
        clientType={clientType}
        assessmentId={assessmentId}
      />
      {[1].map(index => (
        <div className="mb-4">
          <RecommendationForm
            key={index}
            index={index}
            setFieldValue={setFieldValue}
            values={values}
            fieldName={fieldName}
            getTemplateOptions={getTemplateOptions}
            openModal={open}
            charLimit={charLimit}
          />
        </div>
      ))}
    </div>
  );
};

const RecommendationForm = ({ index, setFieldValue, values, fieldName, getTemplateOptions, openModal, charLimit = 1500 }) => {
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  const handleTemplateSelect = (selected) => {
    setSelectedTemplate(selected);
    // setFieldValue(`${fieldName}?.answer`, { id: values?.[fieldName]?.[index]?.id ? values?.[fieldName]?.[index]?.id : null, answers: selected?.value?.answers || "", attachmentData: values?.[fieldName]?.[index]?.attachmentData })
    setFieldValue(`${fieldName}`, { id: values?.[fieldName]?.id ? values?.[fieldName]?.id : null, answer: selected?.value?.answers || "" })
  }

  return (
    <>
      <div className="d-flex justify-content-between gap-3 align-items-center" style={{ borderBottom: "0.75px solid #000000", padding: "12px 0" }}>
        <p className="text-uppercase m-0 fw-sbold themeBlue" style={{ whiteSpace: "nowrap" }}>Recommendation</p>
        <div className="w-100">
          <CustomAsyncSelect
            placeholder={"(no template selected)"}
            loadOptions={getTemplateOptions}
            onChange={(selected) => handleTemplateSelect(selected)}
            value={selectedTemplate}
            defaultOptions={true}
          // isFilter={true}
          // isClearable
          />
        </div>
      </div>
      <div className="ck-editor-wrapper my-2">
        <CustomEditor limit={charLimit} name={`${fieldName}.answer`} />
        {/* <CKEditorField
          key={index}
          items={[
            'bold',
            'italic',
            'underline',
            'alignment',
            '|',
            'bulletedList',
            'numberedList',
          ]}
          value={values[fieldName][index]?.answers}
          handleChange={(event, editor) => {
            setFieldValue(`${fieldName}[${index}].answers`, editor?.getData());
          }}
        /> */}
      </div>
      <button
        className="blue-discharge-screen-btn"
        type="button"
        onClick={() => {
          openModal({
            // name: values[fieldName][index]?.name,
            answers: values[fieldName]?.answer,
          });
        }}
      >
        Save to Templates
      </button>
    </>
  )
}

export default QuestionSingleRecommendation;